<template>
<div v-show="isModalVisible">
<div class="modal-mask" @click="closeModal">
      <div class="modal-container" @click.stop>
      <!-- Modal Header -->
      <div class="modal-header">
        <div class="sub-heading"><h3>Edit Assessment Section</h3></div>
        <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
      </div>
      <!-- Modal body -->
      <div class="modal-body" v-show="!loading">
        
        <div class="col-8 override-padding">
          <div class="col-lg-4 float-left padding-lr-5" style="padding-left: 0;">
          <input v-model="edit_assessment_section_title"
            name="edit_assessment_section_title"
            placeholder="Enter Section Title..."
            class="col-lg-12 padding-lr-5 input-text form-control"
            v-validate="'required'"
            style="line-height: 30px; margin-right: 10px;"
            maxlength="255" />
            <div v-if="verrors.firstByRule('edit_assessment_section_title', 'required')" class="margin-bottom-5 validate-warning-msg">Assessment Section Title is required</div>
          </div>
          <div class="col-lg-3 float-left padding-lr-5">
           <b-form-select
            class="input-text col-lg-12 padding-lr-5"
            v-model="edit_scale"
            name="edit_scale"
            v-validate="'required'"
            :options="scale_options"
           >
          </b-form-select>
          <div v-if="verrors.firstByRule('edit_scale', 'required')" class="margine-bottom-5 validate-warning-msg">Scale is required</div>
          </div>
          <div class="col-lg-3 float-left padding-lr-5">
           <b-form-select
            class="input-text col-lg-12 padding-lr-5"
            v-model="edit_section_type"
            name="edit_section_type"
            v-validate="'required'"
            :options="section_type_options"
            @change="editSectionRangeDisplay()"
           >
          </b-form-select>
          <div v-if="verrors.firstByRule('edit_section_type', 'required')" class="margin-bottom-5 validate-warning-msg">Type is required</div>
          </div>
        </div>
         
        <div style="clear:both;margin-bottom: 10px;"></div>
        <div class="col-11 override-padding">
          <div class="add-statement-heading">
            Add Statements/Questions
          </div>
        </div>
        <div class="col-11 override-padding">
          <div class="heading-row">
            <div class="col-1 float-left">#</div>
            <div class="col-2 float-left padding-lr-5" v-if="edit_section_range_display == true">Group</div>
            <div class="col-2 float-left padding-lr-5">Type</div>
            <div class="col-7 float-left padding-lr-5">Statement/Question Text</div>
          </div>
        </div>
        <div class="col-11 override-padding float-left" style="margin-top: 10px;">
          <div class="statement-row col-12 override-padding float-left" v-for="(list, sindex in edit_statement_questions" :key="sindex" style="margin-bottom: 5px;">
            <div class="col-1 float-left" style="font-weight: bold; margin-top: 5px;">{{ sindex + 1}}</div>
            <div class="col-2 float-left padding-lr-5" v-if="edit_section_range_display == true">
             <b-form-select
              v-on:change="captureModificaton(sindex)"
              class="input-text col-lg-12 float-left padding-lr-5"
              v-model="list.group"
              :ref="'group_' + sindex"
              :options="group_options"
             >
             </b-form-select>
            </div>
            <div class="col-2 float-left padding-lr-5">
             <b-form-select
              v-on:change="captureModificaton(sindex)"
              class="input-text col-lg-12 float-left padding-lr-5"
              v-model="list.type"
              :ref="'type_' + sindex"
              :options="type_options"
             >
             </b-form-select>
            </div>
            <div class="col-6 float-left padding-lr-5" style="padding-right: 0">
              <input v-model="list.text"
                v-on:change="captureModificaton(sindex)"
                placeholder="Enter Statement/Question"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                :ref="'text_' + sindex"
                maxlength="255" />
            </div>
            <div class="col-1 float-left delete-icon" style="font-weight: bold; margin-top: 5px;" v-if="edit_statement_questions.length > 1">
              <i class="fa fa-window-close cursor-pointer" aria-hidden="true" @click="removeQuestions(sindex)"></i>
            </div>
          </div>
        </div>
        <div style="clear:both; margin-bottom: 5px;"></div>
        <div class="col-11 override-padding">
          <div class="col-5 override-padding float-left">
            &nbsp;
          </div>
          <div class="col-7 padding-lr-5 float-left add-on " v-on:click="editAddMoreQuestions()">
            <i class="fa fa-plus spacer-icon" aria-hidden="true"></i> Add Statement/Question (100 Max)
          </div>
        </div>
        <div style="clear:both;margin-bottom: 10px;"></div>
        <div class="col-11 override-padding" v-if="edit_section_range_display == true">
          <div class="add-statement-heading">
            Enter Output Ranges and Text
          </div>
        </div>
        <div class="col-11 override-padding collapse-wrapper" v-show="editCheckVisible('A')">
          <b-link v-b-toggle="'collapse-A'" >
            <div>
              Group A
              <i class="fa fa-angle-up" aria-hidden="true"></i>
            </div>
          </b-link>
        </div>
        <b-collapse v-bind:id="'collapse-A'" class="mt-2" visible v-show="editCheckVisible('A')">

        <div class="col-11 override-padding">
          <div class="heading-row">
            <div class="col-1 float-left padding-lr-5">From</div>
            <div class="col-1 float-left padding-lr-5 text-align-center">>/<</div>
            <div class="col-1 float-left padding-lr-5">To</div>
            <div class="col-9 float-left padding-lr-5">Output Text</div>
          </div>
        </div>
        <div class="col-11 override-padding float-left" style="margin-top: 10px;">
          <div class="statement-row col-12 override-padding float-left" style="margin-bottom: 5px;" v-for="(list, aindex) in edit_group_a_range" :key="aindex">
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.from"
                v-on:blur="editCheckRangeNumbers(aindex, 'From', 'A')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-1 float-left padding-lr-5 text-align-center" style="margin-top: 5px;">
              -
            </div>
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.to"
                v-on:blur="editCheckRangeNumbers(aindex, 'To', 'A')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-8 float-left padding-lr-5" style="padding-right: 0;">
              <vue-editor v-model="list.text" :editorToolbar="customToolbar"></vue-editor>
            </div>
            <div class="col-1 float-left delete-icon" style="font-weight: bold; margin-top: 5px;" v-if="edit_group_a_range.length > 1">
              <i class="fa fa-window-close cursor-pointer" aria-hidden="true" @click="removeGroupRange(aindex, 'A')"></i>
            </div>            

          </div>
        </div>
        <div style="clear:both; margin-bottom: 5px;"></div>
        <div class="col-11 override-padding">
          <div class="col-3 override-padding float-left">
            &nbsp;
          </div>
          <div class="col-9 padding-lr-5 float-left add-on" v-on:click="editAddMoreOutputText('A')">
            <i class="fa fa-plus spacer-icon" aria-hidden="true"></i> <span style="font-style: italic">Add Score Range (25 Max) </span>
          </div>
        </div>
        </b-collapse>
        <div style="clear:both;margin-bottom: 10px;"></div>

        <div class="col-11 overridepadding collapse-wrapper" v-show="editCheckVisible('B')">
          <b-link v-b-toggle="'collapse-B'">
            <div>
              Group B
              <i class="fa fa-angle-up" aria-hidden="true"></i>
            </div>
          </b-link>
        </div>
        <b-collapse v-bind:id="'collapse-B'" class="mt-2" visible v-show="editCheckVisible('B')">

        <div class="col-11 override-padding">
          <div class="heading-row">
            <div class="col-1 float-left padding-lr-5">From</div>
            <div class="col-1 float-left padding-lr-5 text-align-center">>/<</div>
            <div class="col-1 float-left padding-lr-5">To</div>
            <div class="col-9 float-left padding-lr-5">Output Text</div>
          </div>
        </div>
        <div class="col-11 override-padding float-left" style="margin-top: 10px;">
          <div class="statement-row col-12 override-padding float-left" style="margin-bottom: 5px;"  v-for="(list, bindex) in edit_group_b_range" :key="bindex">
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.from"
                v-on:blur="editCheckRangeNumbers(bindex, 'From', 'B')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-1 float-left padding-lr-5 text-align-center" style="margin-top: 5px;">
              -
            </div>
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.to"
                v-on:blur="editCheckRangeNumbers(bindex, 'To', 'B')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-8 float-left padding-lr-5" style="padding-right: 0;">
              <vue-editor v-model="list.text" :editorToolbar="customToolbar"></vue-editor>
            </div>
            <div class="col-1 float-left delete-icon" style="font-weight: bold; margin-top: 5px;" v-if="edit_group_b_range.length > 1">
              <i class="fa fa-window-close cursor-pointer" aria-hidden="true" @click="removeGroupRange(bindex, 'B')"></i>
            </div>
          </div>
        </div>
        <div style="clear:both; margin-bottom: 5px;"></div>
        <div class="col-11 override-padding">
          <div class="col-3 override-padding float-left">
            &nbsp;
          </div>
          <div class="col-9 padding-lr-5 float-left add-on" v-on:click="editAddMoreOutputText('B')">
            <i class="fa fa-plus spacer-icon" aria-hidden="true"></i> <span style="font-style: italic">Add Score Range (25 Max) </span>
          </div>
        </div>
        </b-collapse>

        <div style="clear:both;margin-bottom: 10px;"></div>
        <div class="col-11 overridepadding collapse-wrapper" v-show="editCheckVisible('C')">
          <b-link v-b-toggle="'collapse-C'">
            <div>
              Group C
              <i class="fa fa-angle-up" aria-hidden="true"></i>
            </div>
          </b-link>
        </div>
        <b-collapse v-bind:id="'collapse-C'" class="mt-2" visible v-show="editCheckVisible('C')">

        <div class="col-11 override-padding">
          <div class="heading-row">
            <div class="col-1 float-left padding-lr-5">From</div>
            <div class="col-1 float-left padding-lr-5 text-align-center">>/<</div>
            <div class="col-1 float-left padding-lr-5">To</div>
            <div class="col-9 float-left padding-lr-5">Output Text</div>
          </div>
        </div>
        <div class="col-11 override-padding float-left" style="margin-top: 10px;">
          <div class="statement-row col-12 override-padding float-left" style="margin-bottom: 5px;"  v-for="(list, bindex) in edit_group_c_range" :key="bindex">
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.from"
                v-on:blur="editCheckRangeNumbers(bindex, 'From', 'C')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-1 float-left padding-lr-5 text-align-center" style="margin-top: 5px;">
              -
            </div>
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.to"
                v-on:blur="editCheckRangeNumbers(bindex, 'To', 'C')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-8 float-left padding-lr-5" style="padding-right: 0;">
              <vue-editor v-model="list.text" :editorToolbar="customToolbar"></vue-editor>
            </div>
            <div class="col-1 float-left delete-icon" style="font-weight: bold; margin-top: 5px;" v-if="edit_group_c_range.length > 1">
              <i class="fa fa-window-close cursor-pointer" aria-hidden="true" @click="removeGroupRange(bindex, 'C')"></i>
            </div>
          </div>
        </div>
        <div style="clear:both; margin-bottom: 5px;"></div>
        <div class="col-11 override-padding">
          <div class="col-3 override-padding float-left">
            &nbsp;
          </div>
          <div class="col-9 padding-lr-5 float-left add-on" v-on:click="editAddMoreOutputText('C')">
            <i class="fa fa-plus spacer-icon" aria-hidden="true"></i> <span style="font-style: italic">Add Score Range (25 Max) </span>
          </div>
        </div>
        </b-collapse>

        <div style="clear:both;margin-bottom: 10px;"></div>
        <div class="col-11 overridepadding collapse-wrapper" v-show="editCheckVisible('D')">
          <b-link v-b-toggle="'collapse-D'">
            <div>
              Group D
              <i class="fa fa-angle-up" aria-hidden="true"></i>
            </div>
          </b-link>
        </div>
        <b-collapse v-bind:id="'collapse-D'" class="mt-2" visible v-show="editCheckVisible('D')">

        <div class="col-11 override-padding">
          <div class="heading-row">
            <div class="col-1 float-left padding-lr-5">From</div>
            <div class="col-1 float-left padding-lr-5 text-align-center">>/<</div>
            <div class="col-1 float-left padding-lr-5">To</div>
            <div class="col-9 float-left padding-lr-5">Output Text</div>
          </div>
        </div>
        <div class="col-11 override-padding float-left" style="margin-top: 10px;">
          <div class="statement-row col-12 override-padding float-left" style="margin-bottom: 5px;"  v-for="(list, bindex) in edit_group_d_range" :key="bindex">
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.from"
                v-on:blur="editCheckRangeNumbers(bindex, 'From', 'D')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-1 float-left padding-lr-5 text-align-center" style="margin-top: 5px;">
              -
            </div>
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.to"
                v-on:blur="editCheckRangeNumbers(bindex, 'To', 'D')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-8 float-left padding-lr-5" style="padding-right: 0;">
              <vue-editor v-model="list.text" :editorToolbar="customToolbar"></vue-editor>
            </div>
            <div class="col-1 float-left delete-icon" style="font-weight: bold; margin-top: 5px;" v-if="edit_group_d_range.length > 1">
              <i class="fa fa-window-close cursor-pointer" aria-hidden="true" @click="removeGroupRange(bindex, 'D')"></i>
            </div>
          </div>
        </div>
        <div style="clear:both; margin-bottom: 5px;"></div>
        <div class="col-11 override-padding">
          <div class="col-3 override-padding float-left">
            &nbsp;
          </div>
          <div class="col-9 padding-lr-5 float-left add-on" v-on:click="editAddMoreOutputText('D')">
            <i class="fa fa-plus spacer-icon" aria-hidden="true"></i> <span style="font-style: italic">Add Score Range (25 Max) </span>
          </div>
        </div>
        </b-collapse>

        <div style="clear:both;margin-bottom: 10px;"></div>
        <div class="col-11 overridepadding collapse-wrapper" v-show="editCheckVisible('E')">
          <b-link v-b-toggle="'collapse-E'">
            <div>
              Group E
              <i class="fa fa-angle-up" aria-hidden="true"></i>
            </div>
          </b-link>
        </div>
        <b-collapse v-bind:id="'collapse-E'" class="mt-2" visible v-show="editCheckVisible('E')">

        <div class="col-11 override-padding">
          <div class="heading-row">
            <div class="col-1 float-left padding-lr-5">From</div>
            <div class="col-1 float-left padding-lr-5 text-align-center">>/<</div>
            <div class="col-1 float-left padding-lr-5">To</div>
            <div class="col-9 float-left padding-lr-5">Output Text</div>
          </div>
        </div>
        <div class="col-11 override-padding float-left" style="margin-top: 10px;">
          <div class="statement-row col-12 override-padding float-left" style="margin-bottom: 5px;"  v-for="(list, bindex) in edit_group_e_range" :key="bindex">
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.from"
                v-on:blur="editCheckRangeNumbers(bindex, 'From', 'E')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-1 float-left padding-lr-5 text-align-center" style="margin-top: 5px;">
              -
            </div>
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.to"
                v-on:blur="editCheckRangeNumbers(bindex, 'To', 'E')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-8 float-left padding-lr-5" style="padding-right: 0;">
              <vue-editor v-model="list.text" :editorToolbar="customToolbar"></vue-editor>
            </div>
            <div class="col-1 float-left delete-icon" style="font-weight: bold; margin-top: 5px;" v-if="edit_group_e_range.length > 1">
              <i class="fa fa-window-close cursor-pointer" aria-hidden="true" @click="removeGroupRange(bindex, 'E')"></i>
            </div>
          </div>
        </div>
        <div style="clear:both; margin-bottom: 5px;"></div>
        <div class="col-11 override-padding">
          <div class="col-3 override-padding float-left">
            &nbsp;
          </div>
          <div class="col-9 padding-lr-5 float-left add-on" v-on:click="editAddMoreOutputText('E')">
            <i class="fa fa-plus spacer-icon" aria-hidden="true"></i> <span style="font-style: italic">Add Score Range (25 Max) </span>
          </div>
        </div>
        </b-collapse>

        <div style="clear:both;margin-bottom: 10px;"></div>
        <div class="col-11 overridepadding collapse-wrapper" v-show="editCheckVisible('F')">
          <b-link v-b-toggle="'collapse-F'">
            <div>
              Group F
              <i class="fa fa-angle-up" aria-hidden="true"></i>
            </div>
          </b-link>
        </div>
        <b-collapse v-bind:id="'collapse-F'" class="mt-2" visible v-show="editCheckVisible('F')">

        <div class="col-11 override-padding">
          <div class="heading-row">
            <div class="col-1 float-left padding-lr-5">From</div>
            <div class="col-1 float-left padding-lr-5 text-align-center">>/<</div>
            <div class="col-1 float-left padding-lr-5">To</div>
            <div class="col-9 float-left padding-lr-5">Output Text</div>
          </div>
        </div>
        <div class="col-11 override-padding float-left" style="margin-top: 10px;">
          <div class="statement-row col-12 override-padding float-left" style="margin-bottom: 5px;"  v-for="(list, bindex) in edit_group_f_range" :key="bindex">
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.from"
                v-on:blur="editCheckRangeNumbers(bindex, 'From', 'F')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-1 float-left padding-lr-5 text-align-center" style="margin-top: 5px;">
              -
            </div>
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.to"
                v-on:blur="editCheckRangeNumbers(bindex, 'To', 'F')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-8 float-left padding-lr-5" style="padding-right: 0;">
              <vue-editor v-model="list.text" :editorToolbar="customToolbar"></vue-editor>
            </div>
            <div class="col-1 float-left delete-icon" style="font-weight: bold; margin-top: 5px;" v-if="edit_group_f_range.length > 1">
              <i class="fa fa-window-close cursor-pointer" aria-hidden="true" @click="removeGroupRange(bindex, 'F')"></i>
            </div>
          </div>
        </div>
        <div style="clear:both; margin-bottom: 5px;"></div>
        <div class="col-11 override-padding">
          <div class="col-3 override-padding float-left">
            &nbsp;
          </div>
          <div class="col-9 padding-lr-5 float-left add-on" v-on:click="editAddMoreOutputText('F')">
            <i class="fa fa-plus spacer-icon" aria-hidden="true"></i> <span style="font-style: italic">Add Score Range (25 Max) </span>
          </div>
        </div>
        </b-collapse>

        <div style="clear:both;margin-bottom: 10px;"></div>
        <div class="col-11 overridepadding collapse-wrapper" v-show="editCheckVisible('G')">
          <b-link v-b-toggle="'collapse-G'">
            <div>
              Group G
              <i class="fa fa-angle-up" aria-hidden="true"></i>
            </div>
          </b-link>
        </div>
        <b-collapse v-bind:id="'collapse-G'" class="mt-2" visible v-show="editCheckVisible('G')">

        <div class="col-11 override-padding">
          <div class="heading-row">
            <div class="col-1 float-left padding-lr-5">From</div>
            <div class="col-1 float-left padding-lr-5 text-align-center">>/<</div>
            <div class="col-1 float-left padding-lr-5">To</div>
            <div class="col-9 float-left padding-lr-5">Output Text</div>
          </div>
        </div>
        <div class="col-11 override-padding float-left" style="margin-top: 10px;">
          <div class="statement-row col-12 override-padding float-left" style="margin-bottom: 5px;"  v-for="(list, bindex) in edit_group_g_range" :key="bindex">
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.from"
                v-on:blur="editCheckRangeNumbers(bindex, 'From', 'G')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-1 float-left padding-lr-5 text-align-center" style="margin-top: 5px;">
              -
            </div>
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.to"
                v-on:blur="editCheckRangeNumbers(bindex, 'To', 'G')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-8 float-left padding-lr-5" style="padding-right: 0;">
              <vue-editor v-model="list.text" :editorToolbar="customToolbar"></vue-editor>
            </div>
            <div class="col-1 float-left delete-icon" style="font-weight: bold; margin-top: 5px;" v-if="edit_group_g_range.length > 1">
              <i class="fa fa-window-close cursor-pointer" aria-hidden="true" @click="removeGroupRange(bindex, 'G')"></i>
            </div>
          </div>
        </div>
        <div style="clear:both; margin-bottom: 5px;"></div>
        <div class="col-11 override-padding">
          <div class="col-3 override-padding float-left">
            &nbsp;
          </div>
          <div class="col-9 padding-lr-5 float-left add-on" v-on:click="editAddMoreOutputText('G')">
            <i class="fa fa-plus spacer-icon" aria-hidden="true"></i> <span style="font-style: italic">Add Score Range (25 Max) </span>
          </div>
        </div>
        </b-collapse>

        <div style="clear:both;margin-bottom: 10px;"></div>
        <div class="col-11 overridepadding collapse-wrapper" v-show="editCheckVisible('H')">
          <b-link v-b-toggle="'collapse-H'">
            <div>
              Group H
              <i class="fa fa-angle-up" aria-hidden="true"></i>
            </div>
          </b-link>
        </div>
        <b-collapse v-bind:id="'collapse-H'" class="mt-2" visible v-show="editCheckVisible('H')">

        <div class="col-11 override-padding">
          <div class="heading-row">
            <div class="col-1 float-left padding-lr-5">From</div>
            <div class="col-1 float-left padding-lr-5 text-align-center">>/<</div>
            <div class="col-1 float-left padding-lr-5">To</div>
            <div class="col-9 float-left padding-lr-5">Output Text</div>
          </div>
        </div>
        <div class="col-11 override-padding float-left" style="margin-top: 10px;">
          <div class="statement-row col-12 override-padding float-left" style="margin-bottom: 5px;"  v-for="(list, bindex) in edit_group_h_range" :key="bindex">
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.from"
                v-on:blur="editCheckRangeNumbers(bindex, 'From', 'H')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-1 float-left padding-lr-5 text-align-center" style="margin-top: 5px;">
              -
            </div>
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.to"
                v-on:blur="editCheckRangeNumbers(bindex, 'To', 'H')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-8 float-left padding-lr-5" style="padding-right: 0;">
              <vue-editor v-model="list.text" :editorToolbar="customToolbar"></vue-editor>
            </div>
            <div class="col-1 float-left delete-icon" style="font-weight: bold; margin-top: 5px;" v-if="edit_group_h_range.length > 1">
              <i class="fa fa-window-close cursor-pointer" aria-hidden="true" @click="removeGroupRange(bindex, 'H')"></i>
            </div>
          </div>
        </div>
        <div style="clear:both; margin-bottom: 5px;"></div>
        <div class="col-11 override-padding">
          <div class="col-3 override-padding float-left">
            &nbsp;
          </div>
          <div class="col-9 padding-lr-5 float-left add-on" v-on:click="editAddMoreOutputText('H')">
            <i class="fa fa-plus spacer-icon" aria-hidden="true"></i> <span style="font-style: italic">Add Score Range (25 Max) </span>
          </div>
        </div>
        </b-collapse>

        <div style="clear:both;margin-bottom: 10px;"></div>
        <div class="col-11 overridepadding collapse-wrapper" v-show="editCheckVisible('I')">
          <b-link v-b-toggle="'collapse-I'">
            <div>
              Group I
              <i class="fa fa-angle-up" aria-hidden="true"></i>
            </div>
          </b-link>
        </div>
        <b-collapse v-bind:id="'collapse-I'" class="mt-2" visible v-show="editCheckVisible('I')">

        <div class="col-11 override-padding">
          <div class="heading-row">
            <div class="col-1 float-left padding-lr-5">From</div>
            <div class="col-1 float-left padding-lr-5 text-align-center">>/<</div>
            <div class="col-1 float-left padding-lr-5">To</div>
            <div class="col-9 float-left padding-lr-5">Output Text</div>
          </div>
        </div>
        <div class="col-11 override-padding float-left" style="margin-top: 10px;">
          <div class="statement-row col-12 override-padding float-left" style="margin-bottom: 5px;"  v-for="(list, bindex) in edit_group_i_range" :key="bindex">
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.from"
                v-on:blur="editCheckRangeNumbers(bindex, 'From', 'I')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-1 float-left padding-lr-5 text-align-center" style="margin-top: 5px;">
              -
            </div>
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.to"
                v-on:blur="editCheckRangeNumbers(bindex, 'To', 'I')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-8 float-left padding-lr-5" style="padding-right: 0;">
              <vue-editor v-model="list.text" :editorToolbar="customToolbar"></vue-editor>
            </div>
            <div class="col-1 float-left delete-icon" style="font-weight: bold; margin-top: 5px;" v-if="edit_group_i_range.length > 1">
              <i class="fa fa-window-close cursor-pointer" aria-hidden="true" @click="removeGroupRange(bindex, 'I')"></i>
            </div>
          </div>
        </div>
        <div style="clear:both; margin-bottom: 5px;"></div>
        <div class="col-11 override-padding">
          <div class="col-3 override-padding float-left">
            &nbsp;
          </div>
          <div class="col-9 padding-lr-5 float-left add-on" v-on:click="editAddMoreOutputText('I')">
            <i class="fa fa-plus spacer-icon" aria-hidden="true"></i> <span style="font-style: italic">Add Score Range (25 Max) </span>
          </div>
        </div>
        </b-collapse>

        <div style="clear:both;margin-bottom: 10px;"></div>
        <div class="col-11 overridepadding collapse-wrapper" v-show="editCheckVisible('J')">
          <b-link v-b-toggle="'collapse-J'">
            <div>
              Group J
              <i class="fa fa-angle-up" aria-hidden="true"></i>
            </div>
          </b-link>
        </div>
        <b-collapse v-bind:id="'collapse-J'" class="mt-2" visible v-show="editCheckVisible('J')">

        <div class="col-11 override-padding">
          <div class="heading-row">
            <div class="col-1 float-left padding-lr-5">From</div>
            <div class="col-1 float-left padding-lr-5 text-align-center">>/<</div>
            <div class="col-1 float-left padding-lr-5">To</div>
            <div class="col-9 float-left padding-lr-5">Output Text</div>
          </div>
        </div>
        <div class="col-11 override-padding float-left" style="margin-top: 10px;">
          <div class="statement-row col-12 override-padding float-left" style="margin-bottom: 5px;"  v-for="(list, bindex) in edit_group_j_range" :key="bindex">
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.from"
                v-on:blur="editCheckRangeNumbers(bindex, 'From', 'J')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-1 float-left padding-lr-5 text-align-center" style="margin-top: 5px;">
              -
            </div>
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.to"
                v-on:blur="editCheckRangeNumbers(bindex, 'To', 'J')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-8 float-left padding-lr-5" style="padding-right: 0;">
              <vue-editor v-model="list.text" :editorToolbar="customToolbar"></vue-editor>
            </div>
            <div class="col-1 float-left delete-icon" style="font-weight: bold; margin-top: 5px;" v-if="edit_group_j_range.length > 1">
              <i class="fa fa-window-close cursor-pointer" aria-hidden="true" @click="removeGroupRange(bindex, 'J')"></i>
            </div>
          </div>
        </div>
        <div style="clear:both; margin-bottom: 5px;"></div>
        <div class="col-11 override-padding">
          <div class="col-3 override-padding float-left">
            &nbsp;
          </div>
          <div class="col-9 padding-lr-5 float-left add-on" v-on:click="editAddMoreOutputText('J')">
            <i class="fa fa-plus spacer-icon" aria-hidden="true"></i> <span style="font-style: italic">Add Score Range (25 Max) </span>
          </div>
        </div>
        </b-collapse>

        <div style="clear:both;margin-bottom: 10px;"></div>
        <div class="col-11 overridepadding collapse-wrapper" v-show="editCheckVisible('K')">
          <b-link v-b-toggle="'collapse-K'">
            <div>
              Group K
              <i class="fa fa-angle-up" aria-hidden="true"></i>
            </div>
          </b-link>
        </div>
        <b-collapse v-bind:id="'collapse-K'" class="mt-2" visible v-show="editCheckVisible('K')">

        <div class="col-11 override-padding">
          <div class="heading-row">
            <div class="col-1 float-left padding-lr-5">From</div>
            <div class="col-1 float-left padding-lr-5 text-align-center">>/<</div>
            <div class="col-1 float-left padding-lr-5">To</div>
            <div class="col-9 float-left padding-lr-5">Output Text</div>
          </div>
        </div>
        <div class="col-11 override-padding float-left" style="margin-top: 10px;">
          <div class="statement-row col-12 override-padding float-left" style="margin-bottom: 5px;"  v-for="(list, bindex) in edit_group_k_range" :key="bindex">
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.from"
                v-on:blur="editCheckRangeNumbers(bindex, 'From', 'K')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-1 float-left padding-lr-5 text-align-center" style="margin-top: 5px;">
              -
            </div>
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.to"
                v-on:blur="editCheckRangeNumbers(bindex, 'To', 'K')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-8 float-left padding-lr-5" style="padding-right: 0;">
              <vue-editor v-model="list.text" :editorToolbar="customToolbar"></vue-editor>
            </div>
            <div class="col-1 float-left delete-icon" style="font-weight: bold; margin-top: 5px;" v-if="edit_group_k_range.length > 1">
              <i class="fa fa-window-close cursor-pointer" aria-hidden="true" @click="removeGroupRange(bindex, 'K')"></i>
            </div>
          </div>
        </div>
        <div style="clear:both; margin-bottom: 5px;"></div>
        <div class="col-11 override-padding">
          <div class="col-3 override-padding float-left">
            &nbsp;
          </div>
          <div class="col-9 padding-lr-5 float-left add-on" v-on:click="editAddMoreOutputText('K')">
            <i class="fa fa-plus spacer-icon" aria-hidden="true"></i> <span style="font-style: italic">Add Score Range (25 Max) </span>
          </div>
        </div>
        </b-collapse>

        <div style="clear:both;margin-bottom: 10px;"></div>
        <div class="col-11 override-padding">
            <div class="col-lg-2 col-md-4 col-4 padding-lr-5 float-right"  style="padding-right: 0px;">
              <button
                v-on:click="editAssessmentSection()"
                class="btn btn-red col-12 override-padding" style="margin-top: 2px; height: 32px; border-radius: 10px;"
                >Update</button>
            </div>
        </div>
        <div style="clear: both;margin-bottom: 15px;"></div>
        <hr class="custom_hr">
        <div class="reps_history_label">
          <a href="javascript:void(0);" @click="showSectionHistory">
            Assessment Audit Trail <i :class="toggleFontIcon" style="font-size: 18px;"></i>
          </a>
        </div>
        <SectionHistory 
          :sectionId="sectionId"
          ref="section_history"
        >
        </SectionHistory>

      </div>
      <!-- Modal footer -->
      <div class="modal-footer">
        
      </div>
     </div>
</div>
</div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import SectionHistory from './section_history';
import { VueEditor } from "vue2-editor";

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  props: ['isModalVisible', 'sectionId'],
  data() {
    return {
      scale_options: [
        { value: '', text: 'Select Scale' },
        { value: '1', text: '1-3:D/N/A' },
        { value: '2', text: '1-5:SD/D/N/A/SA' },
        { value: '3', text: '1-7:VSD/SD/D/N/A/SA/VSA' }
      ],
      group_options: [
        { value: '', text: 'Select' },
        { value: 'A', text: 'A' },
        { value: 'B', text: 'B' },
        { value: 'C', text: 'C' },
        { value: 'D', text: 'D' },
        { value: 'E', text: 'E' },
        { value: 'F', text: 'F' },
        { value: 'G', text: 'G' },
        { value: 'H', text: 'H' },
        { value: 'I', text: 'I' },
        { value: 'J', text: 'J' },
        { value: 'K', text: 'K' },
      ],
      type_options: [
        { value: '', text: 'Select' },
        { value: 'Global', text: 'Global' },
        { value: 'Intuitive', text: 'Intuitive' },
        { value: 'Individual', text: 'Individual' },
        { value: 'Negative', text: 'Negative' },
      ],
      edit_section_type: 'output',
      section_type_options: [
        { value: '', text: 'Type' },
        { value: 'output', text: 'Output' },
        { value: 'no-output', text: 'No output' },
      ],
      edit_section_range_display: true,
      edit_statement_questions: [
        {
          id: '',
          update: false,
          modified: false,
          group: '',
          type: '',
          text: '',
        }
      ],
      edit_group_a_range: [
        {
          from: '',
          to: '',
          text: '',
        }
      ],
      edit_group_b_range: [
        {
          from: '',
          to: '',
          text: '',
        }
      ],
      edit_group_c_range: [
        {
          from: '',
          to: '',
          text: '',
        }
      ],
      edit_group_d_range: [
        {
          from: '',
          to: '',
          text: '',
        }
      ],
      edit_group_e_range: [
        {
          from: '',
          to: '',
          text: '',
        }
      ],
      edit_group_f_range: [
        {
          from: '',
          to: '',
          text: '',
        }
      ],
      edit_group_g_range: [
        {
          from: '',
          to: '',
          text: '',
        }
      ],
      edit_group_h_range: [
        {
          from: '',
          to: '',
          text: '',
        }
      ],
      edit_group_i_range: [
        {
          from: '',
          to: '',
          text: '',
        }
      ],
      edit_group_j_range: [
        {
          from: '',
          to: '',
          text: '',
        }
      ],
      edit_group_k_range: [
        {
          from: '',
          to: '',
          text: '',
        }
      ],
      edit_assessment_section_title: '',
      edit_scale: '',
      remove_question_ids: [],
      loading: false,
      toggleFontIcon: 'fa fa-angle-down',
      customToolbar:[["bold", "italic", "underline"]]
    }
  },
  components: {
    SectionHistory,
    VueEditor
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    editSectionRangeDisplay: function() {
      this.edit_section_range_display = true;
      if(this.edit_section_type == 'no-output') {
        this.edit_section_range_display = false;
        for(var i=0; i<this.edit_statement_questions.length; i++) {
          this.edit_statement_questions[i].group = '';
        }
      }
    },
    showSectionHistory() {
      this.$refs.section_history.fetchSectionsHistory();
    },
    removeGroupRange: function(index, group) {
      if(group == 'A') {
        this.edit_group_a_range.splice(index, 1);
      }
      else if(group == 'B') {
        this.edit_group_b_range.splice(index, 1);
      }
      else if(group == 'C') {
        this.edit_group_c_range.splice(index, 1);
      }
      else if(group == 'D') {
        this.edit_group_d_range.splice(index, 1);
      }
      else if(group == 'E') {
        this.edit_group_e_range.splice(index, 1);
      }
      else if(group == 'F') {
        this.edit_group_f_range.splice(index, 1);
      }
      else if(group == 'G') {
        this.edit_group_g_range.splice(index, 1);
      }
      else if(group == 'H') {
        this.edit_group_h_range.splice(index, 1);
      }
      else if(group == 'I') {
        this.edit_group_i_range.splice(index, 1);
      }
      else if(group == 'J') {
        this.edit_group_j_range.splice(index, 1);
      }
      else if(group == 'K') {
        this.edit_group_k_range.splice(index, 1);
      }
    },
    removeQuestions: function(index) {
      var remove_data = this.edit_statement_questions[index];
      this.remove_question_ids.push({
        question_id: remove_data['id'],
      });
      this.edit_statement_questions.splice(index, 1);
    },
    captureModificaton: function(index) {
      var mod_data = this.edit_statement_questions[index];
      if(mod_data.update == true) {
        this.edit_statement_questions[index].modified = true;
      }
      console.log(this.edit_statement_questions[index]);
    },
    fetchSectionDetails: function(section_id) {
      this.loading = true;
      this.remove_question_ids = [];
      axios.get('/assessment-section-questions-lists-edit/' + section_id)
        .then((resp) => {
            this.loading = false;
            this.$refs.section_history.isToggledRepsHistory = false;
            this.edit_assessment_section_title = resp.data.section.title;
            this.edit_scale = resp.data.section.scale;
            this.edit_section_type = resp.data.section.type;
            this.edit_statement_questions = resp.data.questions;
            this.edit_group_a_range = resp.data.group_a_range;
            this.edit_group_b_range = resp.data.group_b_range;
            this.edit_group_c_range = resp.data.group_c_range;
            this.edit_group_d_range = resp.data.group_d_range;
            this.edit_group_e_range = resp.data.group_e_range;
            this.edit_group_f_range = resp.data.group_f_range;
            this.edit_group_g_range = resp.data.group_g_range;
            this.edit_group_h_range = resp.data.group_h_range;
            this.edit_group_i_range = resp.data.group_i_range;
            this.edit_group_j_range = resp.data.group_j_range;
            this.edit_group_k_range = resp.data.group_k_range;
            this.editSectionRangeDisplay();
        })
        .catch(error => {

        });

    },
    editIsNumeric(value){
      var regex = /^[0-9]*$/
      return regex.test(value);
    },
    editCheckRangeNumbers: function(index, arg, group) {
      var scale = this.edit_scale;
      if(this.edit_scale == '') {
        alert("Please select Scale");
        return false;
      }
      if(group == 'A') {
        if(!this.editIsNumeric(this.edit_group_a_range[index].from)) {
          this.edit_group_a_range[index].from = '';
          return false;
        }
        if(!this.editIsNumeric(this.edit_group_a_range[index].to)) {
          this.edit_group_a_range[index].to = '';
          return false;
        }
        var val = this.editGetMinMaxRange(group);
        var minRange = val[0].min;
        var maxRange = val[0].max;
        if((index == 0) && (arg == 'From')) {
          if(parseInt(this.edit_group_a_range[index].from) != parseInt(minRange)) {
            alert("From range should be equal to the count of questions of that group");
            this.edit_group_a_range[index].from = '';
            return false;
          }
        }
        if((index > 0) && (arg == 'From')) {
          var preIndex = parseInt(index-1);
          if(parseInt(this.edit_group_a_range[index].from) <= parseInt(this.edit_group_a_range[preIndex].to)) {
            alert("From range should be higher than the previous To range");
            this.edit_group_a_range[index].from = '';
            return false;
          }
        }
        if((parseInt(index+1) == this.edit_group_a_range.length) && (arg == 'To')) {
          if(parseInt(this.edit_group_a_range[index].to) > parseInt(maxRange)) {
            alert("To range should be lesser or equal to the maximum range");
            this.edit_group_a_range[index].to = '';
            return false;
          }
          else {
            if(parseInt(this.edit_group_a_range[index].from) > parseInt(this.edit_group_a_range[index].to)) {
              alert("To range should be higher than the From range");
              this.edit_group_a_range[index].to = '';
              return false;
            }
          }
        }
        if((parseInt(index+1) < this.edit_group_a_range.length) && (arg == 'To')) {
          if(parseInt(this.edit_group_a_range[index].from) > parseInt(this.edit_group_a_range[index].to)) {
            alert("To range should be higher than the From range");
            this.edit_group_a_range[index].to = '';
            return false;
          }
        }
      }
      else if(group == 'B') {
        if(!this.editIsNumeric(this.edit_group_b_range[index].from)) {
          this.edit_group_b_range[index].from = '';
          return false;
        }
        if(!this.editIsNumeric(this.edit_group_b_range[index].to)) {
          this.edit_group_b_range[index].to = '';
          return false;
        }
        var val = this.editGetMinMaxRange(group);
        var minRange = val[0].min;
        var maxRange = val[0].max;
        if((index == 0) && (arg == 'From')) {
          if(parseInt(this.edit_group_b_range[index].from) != parseInt(minRange)) {
            alert("From range should be equal to the no of questions of that group");
            this.edit_group_b_range[index].from = '';
            return false;
          }
        }
        if((index > 0) && (arg == 'From')) {
          var preIndex = parseInt(index-1);
          if(parseInt(this.edit_group_b_range[index].from) <= parseInt(this.edit_group_b_range[preIndex].to)) {
            alert("From range should be higher than the previous To range");
            this.edit_group_b_range[index].from = '';
            return false;
          }
        }
        if((parseInt(index+1) == this.edit_group_b_range.length) && (arg == 'To')) {
          if(parseInt(this.edit_group_b_range[index].to) > parseInt(maxRange)) {
            alert("To range should be lesser or equal to the maximum range");
            this.edit_group_b_range[index].to = '';
            return false;
          }
          else {
            if(parseInt(this.edit_group_b_range[index].from) > parseInt(this.edit_group_b_range[index].to)) {
              alert("To range should be higher than the From range");
              this.edit_group_b_range[index].to = '';
              return false;
            }
          }
        }
        if((parseInt(index+1) < this.edit_group_b_range.length) && (arg == 'To')) {
          if(parseInt(this.edit_group_b_range[index].from) > parseInt(this.edit_group_b_range[index].to)) {
            alert("To range should be higher than the From range");
            this.edit_group_b_range[index].to = '';
            return false;
          }
        }
      }
      else if(group == 'C') {
        if(!this.editIsNumeric(this.edit_group_c_range[index].from)) {
          this.edit_group_c_range[index].from = '';
          return false;
        }
        if(!this.editIsNumeric(this.edit_group_c_range[index].to)) {
          this.edit_group_c_range[index].to = '';
          return false;
        }
        var val = this.editGetMinMaxRange(group);
        var minRange = val[0].min;
        var maxRange = val[0].max;
        if((index == 0) && (arg == 'From')) {
          if(parseInt(this.edit_group_c_range[index].from) != parseInt(minRange)) {
            alert("From range should be equal to the no of questions of that group");
            this.edit_group_c_range[index].from = '';
            return false;
          }
        }
        if((index > 0) && (arg == 'From')) {
          var preIndex = parseInt(index-1);
          if(parseInt(this.edit_group_c_range[index].from) <= parseInt(this.edit_group_c_range[preIndex].to)) {
            alert("From range should be higher than the previous To range");
            this.edit_group_c_range[index].from = '';
            return false;
          }
        }
        if((parseInt(index+1) == this.edit_group_c_range.length) && (arg == 'To')) {
          if(parseInt(this.edit_group_c_range[index].to) > parseInt(maxRange)) {
            alert("To range should be lesser or equal to the maximum range");
            this.edit_group_c_range[index].to = '';
            return false;
          }
          else {
            if(parseInt(this.edit_group_c_range[index].from) > parseInt(this.edit_group_c_range[index].to)) {
              alert("To range should be higher than the From range");
              this.edit_group_c_range[index].to = '';
              return false;
            }
          }
        }
        if((parseInt(index+1) < this.edit_group_c_range.length) && (arg == 'To')) {
          if(parseInt(this.edit_group_c_range[index].from) > parseInt(this.edit_group_c_range[index].to)) {
            alert("To range should be higher than the From range");
            this.edit_group_c_range[index].to = '';
            return false;
          }
        }
      }
      else if(group == 'D') {
        if(!this.editIsNumeric(this.edit_group_d_range[index].from)) {
          this.edit_group_d_range[index].from = '';
          return false;
        }
        if(!this.editIsNumeric(this.edit_group_d_range[index].to)) {
          this.edit_group_d_range[index].to = '';
          return false;
        }
        var val = this.editGetMinMaxRange(group);
        var minRange = val[0].min;
        var maxRange = val[0].max;
        if((index == 0) && (arg == 'From')) {
          if(parseInt(this.edit_group_d_range[index].from) != parseInt(minRange)) {
            alert("From range should be equal to the no of questions of that group");
            this.edit_group_d_range[index].from = '';
            return false;
          }
        }
        if((index > 0) && (arg == 'From')) {
          var preIndex = parseInt(index-1);
          if(parseInt(this.edit_group_d_range[index].from) <= parseInt(this.edit_group_d_range[preIndex].to)) {
            alert("From range should be higher than the previous To range");
            this.edit_group_d_range[index].from = '';
            return false;
          }
        }
        if((parseInt(index+1) == this.edit_group_d_range.length) && (arg == 'To')) {
          if(parseInt(this.edit_group_d_range[index].to) > parseInt(maxRange)) {
            alert("To range should be lesser or equal to the maximum range");
            this.edit_group_d_range[index].to = '';
            return false;
          }
          else {
            if(parseInt(this.edit_group_d_range[index].from) > parseInt(this.edit_group_d_range[index].to)) {
              alert("To range should be higher than the From range");
              this.edit_group_d_range[index].to = '';
              return false;
            }
          }
        }
        if((parseInt(index+1) < this.edit_group_d_range.length) && (arg == 'To')) {
          if(parseInt(this.edit_group_d_range[index].from) > parseInt(this.edit_group_d_range[index].to)) {
            alert("To range should be higher than the From range");
            this.edit_group_d_range[index].to = '';
            return false;
          }
        }
      }
      else if(group == 'E') {
        if(!this.editIsNumeric(this.edit_group_e_range[index].from)) {
          this.edit_group_e_range[index].from = '';
          return false;
        }
        if(!this.editIsNumeric(this.edit_group_e_range[index].to)) {
          this.edit_group_e_range[index].to = '';
          return false;
        }
        var val = this.editGetMinMaxRange(group);
        var minRange = val[0].min;
        var maxRange = val[0].max;
        if((index == 0) && (arg == 'From')) {
          if(parseInt(this.edit_group_e_range[index].from) != parseInt(minRange)) {
            alert("From range should be equal to the no of questions of that group");
            this.edit_group_e_range[index].from = '';
            return false;
          }
        }
        if((index > 0) && (arg == 'From')) {
          var preIndex = parseInt(index-1);
          if(parseInt(this.edit_group_e_range[index].from) <= parseInt(this.edit_group_e_range[preIndex].to)) {
            alert("From range should be higher than the previous To range");
            this.edit_group_e_range[index].from = '';
            return false;
          }
        }
        if((parseInt(index+1) == this.edit_group_e_range.length) && (arg == 'To')) {
          if(parseInt(this.edit_group_e_range[index].to) > parseInt(maxRange)) {
            alert("To range should be lesser or equal to the maximum range");
            this.edit_group_e_range[index].to = '';
            return false;
          }
          else {
            if(parseInt(this.edit_group_e_range[index].from) > parseInt(this.edit_group_e_range[index].to)) {
              alert("To range should be higher than the From range");
              this.edit_group_e_range[index].to = '';
              return false;
            }
          }
        }
        if((parseInt(index+1) < this.edit_group_e_range.length) && (arg == 'To')) {
          if(parseInt(this.edit_group_e_range[index].from) > parseInt(this.edit_group_e_range[index].to)) {
            alert("To range should be higher than the From range");
            this.edit_group_e_range[index].to = '';
            return false;
          }
        }
      }
      else if(group == 'F') {
        if(!this.editIsNumeric(this.edit_group_f_range[index].from)) {
          this.edit_group_f_range[index].from = '';
          return false;
        }
        if(!this.editIsNumeric(this.edit_group_f_range[index].to)) {
          this.edit_group_f_range[index].to = '';
          return false;
        }
        var val = this.editGetMinMaxRange(group);
        var minRange = val[0].min;
        var maxRange = val[0].max;
        if((index == 0) && (arg == 'From')) {
          if(parseInt(this.edit_group_f_range[index].from) != parseInt(minRange)) {
            alert("From range should be equal to the no of questions of that group");
            this.edit_group_f_range[index].from = '';
            return false;
          }
        }
        if((index > 0) && (arg == 'From')) {
          var preIndex = parseInt(index-1);
          if(parseInt(this.edit_group_f_range[index].from) <= parseInt(this.edit_group_f_range[preIndex].to)) {
            alert("From range should be higher than the previous To range");
            this.edit_group_f_range[index].from = '';
            return false;
          }
        }
        if((parseInt(index+1) == this.edit_group_f_range.length) && (arg == 'To')) {
          if(parseInt(this.edit_group_f_range[index].to) > parseInt(maxRange)) {
            alert("To range should be lesser or equal to the maximum range");
            this.edit_group_f_range[index].to = '';
            return false;
          }
          else {
            if(parseInt(this.edit_group_f_range[index].from) > parseInt(this.edit_group_f_range[index].to)) {
              alert("To range should be higher than the From range");
              this.edit_group_f_range[index].to = '';
              return false;
            }
          }
        }
        if((parseInt(index+1) < this.edit_group_f_range.length) && (arg == 'To')) {
          if(parseInt(this.edit_group_f_range[index].from) > parseInt(this.edit_group_f_range[index].to)) {
            alert("To range should be higher than the From range");
            this.edit_group_f_range[index].to = '';
            return false;
          }
        }
      }
      else if(group == 'G') {
        if(!this.editIsNumeric(this.edit_group_g_range[index].from)) {
          this.edit_group_g_range[index].from = '';
          return false;
        }
        if(!this.editIsNumeric(this.edit_group_g_range[index].to)) {
          this.edit_group_g_range[index].to = '';
          return false;
        }
        var val = this.editGetMinMaxRange(group);
        var minRange = val[0].min;
        var maxRange = val[0].max;
        if((index == 0) && (arg == 'From')) {
          if(parseInt(this.edit_group_g_range[index].from) != parseInt(minRange)) {
            alert("From range should be equal to the no of questions of that group");
            this.edit_group_g_range[index].from = '';
            return false;
          }
        }
        if((index > 0) && (arg == 'From')) {
          var preIndex = parseInt(index-1);
          if(parseInt(this.edit_group_g_range[index].from) <= parseInt(this.edit_group_g_range[preIndex].to)) {
            alert("From range should be higher than the previous To range");
            this.edit_group_g_range[index].from = '';
            return false;
          }
        }
        if((parseInt(index+1) == this.edit_group_g_range.length) && (arg == 'To')) {
          if(parseInt(this.edit_group_g_range[index].to) > parseInt(maxRange)) {
            alert("To range should be lesser or equal to the maximum range");
            this.edit_group_g_range[index].to = '';
            return false;
          }
          else {
            if(parseInt(this.edit_group_g_range[index].from) > parseInt(this.edit_group_g_range[index].to)) {
              alert("To range should be higher than the From range");
              this.edit_group_g_range[index].to = '';
              return false;
            }
          }
        }
        if((parseInt(index+1) < this.edit_group_g_range.length) && (arg == 'To')) {
          if(parseInt(this.edit_group_g_range[index].from) > parseInt(this.edit_group_g_range[index].to)) {
            alert("To range should be higher than the From range");
            this.edit_group_g_range[index].to = '';
            return false;
          }
        }
      }
      else if(group == 'H') {
        if(!this.editIsNumeric(this.edit_group_h_range[index].from)) {
          this.edit_group_h_range[index].from = '';
          return false;
        }
        if(!this.editIsNumeric(this.edit_group_h_range[index].to)) {
          this.edit_group_h_range[index].to = '';
          return false;
        }
        var val = this.editGetMinMaxRange(group);
        var minRange = val[0].min;
        var maxRange = val[0].max;
        if((index == 0) && (arg == 'From')) {
          if(parseInt(this.edit_group_h_range[index].from) != parseInt(minRange)) {
            alert("From range should be equal to the no of questions of that group");
            this.edit_group_h_range[index].from = '';
            return false;
          }
        }
        if((index > 0) && (arg == 'From')) {
          var preIndex = parseInt(index-1);
          if(parseInt(this.edit_group_h_range[index].from) <= parseInt(this.edit_group_h_range[preIndex].to)) {
            alert("From range should be higher than the previous To range");
            this.edit_group_h_range[index].from = '';
            return false;
          }
        }
        if((parseInt(index+1) == this.edit_group_h_range.length) && (arg == 'To')) {
          if(parseInt(this.edit_group_h_range[index].to) > parseInt(maxRange)) {
            alert("To range should be lesser or equal to the maximum range");
            this.edit_group_h_range[index].to = '';
            return false;
          }
          else {
            if(parseInt(this.edit_group_h_range[index].from) > parseInt(this.edit_group_h_range[index].to)) {
              alert("To range should be higher than the From range");
              this.edit_group_h_range[index].to = '';
              return false;
            }
          }
        }
        if((parseInt(index+1) < this.edit_group_h_range.length) && (arg == 'To')) {
          if(parseInt(this.edit_group_h_range[index].from) > parseInt(this.edit_group_h_range[index].to)) {
            alert("To range should be higher than the From range");
            this.edit_group_h_range[index].to = '';
            return false;
          }
        }
      }
      else if(group == 'I') {
        if(!this.editIsNumeric(this.edit_group_i_range[index].from)) {
          this.edit_group_i_range[index].from = '';
          return false;
        }
        if(!this.editIsNumeric(this.edit_group_i_range[index].to)) {
          this.edit_group_i_range[index].to = '';
          return false;
        }
        var val = this.editGetMinMaxRange(group);
        var minRange = val[0].min;
        var maxRange = val[0].max;
        if((index == 0) && (arg == 'From')) {
          if(parseInt(this.edit_group_i_range[index].from) != parseInt(minRange)) {
            alert("From range should be equal to the no of questions of that group");
            this.edit_group_i_range[index].from = '';
            return false;
          }
        }
        if((index > 0) && (arg == 'From')) {
          var preIndex = parseInt(index-1);
          if(parseInt(this.edit_group_i_range[index].from) <= parseInt(this.edit_group_i_range[preIndex].to)) {
            alert("From range should be higher than the previous To range");
            this.edit_group_i_range[index].from = '';
            return false;
          }
        }
        if((parseInt(index+1) == this.edit_group_i_range.length) && (arg == 'To')) {
          if(parseInt(this.edit_group_i_range[index].to) > parseInt(maxRange)) {
            alert("To range should be lesser or equal to the maximum range");
            this.edit_group_i_range[index].to = '';
            return false;
          }
          else {
            if(parseInt(this.edit_group_i_range[index].from) > parseInt(this.edit_group_i_range[index].to)) {
              alert("To range should be higher than the From range");
              this.edit_group_i_range[index].to = '';
              return false;
            }
          }
        }
        if((parseInt(index+1) < this.edit_group_i_range.length) && (arg == 'To')) {
          if(parseInt(this.edit_group_i_range[index].from) > parseInt(this.edit_group_i_range[index].to)) {
            alert("To range should be higher than the From range");
            this.edit_group_i_range[index].to = '';
            return false;
          }
        }
      }
      else if(group == 'J') {
        if(!this.editIsNumeric(this.edit_group_j_range[index].from)) {
          this.edit_group_j_range[index].from = '';
          return false;
        }
        if(!this.editIsNumeric(this.edit_group_j_range[index].to)) {
          this.edit_group_j_range[index].to = '';
          return false;
        }
        var val = this.editGetMinMaxRange(group);
        var minRange = val[0].min;
        var maxRange = val[0].max;
        if((index == 0) && (arg == 'From')) {
          if(parseInt(this.edit_group_j_range[index].from) != parseInt(minRange)) {
            alert("From range should be equal to the no of questions of that group");
            this.edit_group_j_range[index].from = '';
            return false;
          }
        }
        if((index > 0) && (arg == 'From')) {
          var preIndex = parseInt(index-1);
          if(parseInt(this.edit_group_j_range[index].from) <= parseInt(this.edit_group_j_range[preIndex].to)) {
            alert("From range should be higher than the previous To range");
            this.edit_group_j_range[index].from = '';
            return false;
          }
        }
        if((parseInt(index+1) == this.edit_group_j_range.length) && (arg == 'To')) {
          if(parseInt(this.edit_group_j_range[index].to) > parseInt(maxRange)) {
            alert("To range should be lesser or equal to the maximum range");
            this.edit_group_j_range[index].to = '';
            return false;
          }
          else {
            if(parseInt(this.edit_group_j_range[index].from) > parseInt(this.edit_group_j_range[index].to)) {
              alert("To range should be higher than the From range");
              this.edit_group_j_range[index].to = '';
              return false;
            }
          }
        }
        if((parseInt(index+1) < this.edit_group_j_range.length) && (arg == 'To')) {
          if(parseInt(this.edit_group_j_range[index].from) > parseInt(this.edit_group_j_range[index].to)) {
            alert("To range should be higher than the From range");
            this.edit_group_j_range[index].to = '';
            return false;
          }
        }
      }
      else if(group == 'K') {
        if(!this.editIsNumeric(this.edit_group_k_range[index].from)) {
          this.edit_group_k_range[index].from = '';
          return false;
        }
        if(!this.editIsNumeric(this.edit_group_k_range[index].to)) {
          this.edit_group_k_range[index].to = '';
          return false;
        }
        var val = this.editGetMinMaxRange(group);
        var minRange = val[0].min;
        var maxRange = val[0].max;
        if((index == 0) && (arg == 'From')) {
          if(parseInt(this.edit_group_k_range[index].from) != parseInt(minRange)) {
            alert("From range should be equal to the no of questions of that group");
            this.edit_group_k_range[index].from = '';
            return false;
          }
        }
        if((index > 0) && (arg == 'From')) {
          var preIndex = parseInt(index-1);
          if(parseInt(this.edit_group_k_range[index].from) <= parseInt(this.edit_group_k_range[preIndex].to)) {
            alert("From range should be higher than the previous To range");
            this.edit_group_k_range[index].from = '';
            return false;
          }
        }
        if((parseInt(index+1) == this.edit_group_k_range.length) && (arg == 'To')) {
          if(parseInt(this.edit_group_k_range[index].to) > parseInt(maxRange)) {
            alert("To range should be lesser or equal to the maximum range");
            this.edit_group_k_range[index].to = '';
            return false;
          }
          else {
            if(parseInt(this.edit_group_k_range[index].from) > parseInt(this.edit_group_k_range[index].to)) {
              alert("To range should be higher than the From range");
              this.edit_group_k_range[index].to = '';
              return false;
            }
          }
        }
        if((parseInt(index+1) < this.edit_group_k_range.length) && (arg == 'To')) {
          if(parseInt(this.edit_group_k_range[index].from) > parseInt(this.edit_group_k_range[index].to)) {
            alert("To range should be higher than the From range");
            this.edit_group_k_range[index].to = '';
            return false;
          }
        }
      }
    },
    editGetMinMaxRange: function(arg) {
      var minmax = [{min: '', max: ''}];
      var min = '';
      var max = '';
      var minScale = '';
      var maxScale = '';
      var count = 0;
        for(var i=0; i<this.edit_statement_questions.length; i++) {
          if((this.edit_statement_questions[i].group == arg)) {
            count += 1;
          }
      }
      var scale = this.edit_scale;
      if(scale == 1) {
        minScale = 1;
        maxScale = 3;
      }
      else if(scale == 2) {
        minScale = 1;
        maxScale = 5;
      }
      else if(scale == 3) {
        minScale = 1;
        maxScale = 7;
      }
      if((minScale != '') && (maxScale != '')) {
        min = parseInt(count) * parseInt(minScale);
        max = parseInt(count) * parseInt(maxScale);
        minmax = [{min: min, max: max}];
      }
      return minmax;
    },

    editCheckVisible: function(arg) {
      var groupA = false;
      var groupB = false;
      var groupC = false;
      var groupD = false;
      var groupE = false;
      var groupF = false;
      var groupG = false;
      var groupH = false;
      var groupI = false;
      var groupJ = false;
      var groupK = false;
      for(var i=0; i<this.edit_statement_questions.length; i++) {
        if((groupA == false) && (this.edit_statement_questions[i].group == 'A')) {
          groupA = true;
        }
        if((groupB == false) && (this.edit_statement_questions[i].group == 'B')) {
          groupB = true;
        }
        if((groupC == false) && (this.edit_statement_questions[i].group == 'C')) {
          groupC = true;
        }
        if((groupD == false) && (this.edit_statement_questions[i].group == 'D')) {
          groupD = true;
        }
        if((groupE == false) && (this.edit_statement_questions[i].group == 'E')) {
          groupE = true;
        }
        if((groupF == false) && (this.edit_statement_questions[i].group == 'F')) {
          groupF = true;
        }
        if((groupG == false) && (this.edit_statement_questions[i].group == 'G')) {
          groupG = true;
        }
        if((groupH == false) && (this.edit_statement_questions[i].group == 'H')) {
          groupH = true;
        }
        if((groupI == false) && (this.edit_statement_questions[i].group == 'I')) {
          groupI = true;
        }
        if((groupJ == false) && (this.edit_statement_questions[i].group == 'J')) {
          groupJ = true;
        }
        if((groupK == false) && (this.edit_statement_questions[i].group == 'K')) {
          groupK = true;
        }
      }

      if(arg == 'A') {
       return groupA;
      }
      else if(arg == 'B') {
        return groupB;
      }
      else if(arg == 'C') {
        return groupC;
      }
      else if(arg == 'D') {
        return groupD;
      }
      else if(arg == 'E') {
        return groupE;
      }
      else if(arg == 'F') {
        return groupF;
      }
      else if(arg == 'G') {
        return groupG;
      }
      else if(arg == 'H') {
        return groupH;
      }
      else if(arg == 'I') {
        return groupI;
      }
      else if(arg == 'J') {
        return groupJ;
      }
      else if(arg == 'K') {
        return groupK;
      }
    },
    editAddMoreOutputText: function(arg) {
      if(arg == 'A') {
        if(this.edit_group_a_range.length >= 25) {
          alert("You can't add more than 25 Output Ranges");
          return false;
        }
        this.edit_group_a_range.push({
          from: '',
          to: '',
          text: '',
        });
      }
      else if(arg == 'B') {
        if(this.edit_group_b_range.length >= 25) {
          alert("You can't add more than 25 Output Ranges");
          return false;
        }
        this.edit_group_b_range.push({
          from: '',
          to: '',
          text: '',
        });
      }
      else if(arg == 'C') {
        if(this.edit_group_c_range.length >= 25) {
          alert("You can't add more than 25 Output Ranges");
          return false;
        }
        this.edit_group_c_range.push({
          from: '',
          to: '',
          text: '',
        });
      }
      else if(arg == 'D') {
        if(this.edit_group_d_range.length >= 25) {
          alert("You can't add more than 25 Output Ranges");
          return false;
        }
        this.edit_group_d_range.push({
          from: '',
          to: '',
          text: '',
        });
      }
      else if(arg == 'E') {
        if(this.edit_group_e_range.length >= 25) {
          alert("You can't add more than 25 Output Ranges");
          return false;
        }
        this.edit_group_e_range.push({
          from: '',
          to: '',
          text: '',
        });
      }
      else if(arg == 'F') {
        if(this.edit_group_f_range.length >= 25) {
          alert("You can't add more than 25 Output Ranges");
          return false;
        }
        this.edit_group_f_range.push({
          from: '',
          to: '',
          text: '',
        });
      }
      else if(arg == 'G') {
        if(this.edit_group_g_range.length >= 25) {
          alert("You can't add more than 25 Output Ranges");
          return false;
        }
        this.edit_group_g_range.push({
          from: '',
          to: '',
          text: '',
        });
      }
      else if(arg == 'H') {
        if(this.edit_group_h_range.length >= 25) {
          alert("You can't add more than 25 Output Ranges");
          return false;
        }
        this.edit_group_h_range.push({
          from: '',
          to: '',
          text: '',
        });
      }
      else if(arg == 'I') {
        if(this.edit_group_i_range.length >= 25) {
          alert("You can't add more than 25 Output Ranges");
          return false;
        }
        this.edit_group_i_range.push({
          from: '',
          to: '',
          text: '',
        });
      }
      else if(arg == 'J') {
        if(this.edit_group_j_range.length >= 25) {
          alert("You can't add more than 25 Output Ranges");
          return false;
        }
        this.edit_group_j_range.push({
          from: '',
          to: '',
          text: '',
        });
      }
      else if(arg == 'K') {
        if(this.edit_group_k_range.length >= 25) {
          alert("You can't add more than 25 Output Ranges");
          return false;
        }
        this.edit_group_k_range.push({
          from: '',
          to: '',
          text: '',
        });
      }
    },
    editAddMoreQuestions: function() {
      if(this.edit_statement_questions.length >= 100) {
        alert("You can't add more than 100 Statement/Questions");
        return false;
      }
      this.edit_statement_questions.push({
        id: '',
        update: false,
        modified: false,
        group: '',
        type: '',
        text: '',
      });
    },
    editdoValidate: function() {
              var sflag = 0;
              var aflag = 0;
              var bflag = 0;
              var cflag = 0;
              var dflag = 0;
              var eflag = 0;
              var fflag = 0;
              var gflag = 0;
              var hflag = 0;
              var iflag = 0;
              var jflag = 0;
              var kflag = 0;
              var vflag = 1;
              for(var i=0; i<this.edit_statement_questions.length; i++) {
                if(this.edit_statement_questions[i].group != '') {
                  sflag = 1;
                }
                if(this.edit_section_range_display == false) {
                  if(this.edit_statement_questions[i].type != '') {
                    sflag = 1;
                  }
                }
                if(this.edit_section_range_display == true) {
                  if(this.edit_statement_questions[i].group == 'A') {
                    aflag = 1;
                  }
                  if(this.edit_statement_questions[i].group == 'B') {
                    bflag = 1;
                  }
                  if(this.edit_statement_questions[i].group == 'C') {
                    cflag = 1;
                  }
                  if(this.edit_statement_questions[i].group == 'D') {
                    dflag = 1;
                  }
                  if(this.edit_statement_questions[i].group == 'E') {
                    eflag = 1;
                  }
                  if(this.edit_statement_questions[i].group == 'F') {
                    fflag = 1;
                  }
                  if(this.edit_statement_questions[i].group == 'G') {
                    gflag = 1;
                  }
                  if(this.edit_statement_questions[i].group == 'H') {
                    hflag = 1;
                  }
                  if(this.edit_statement_questions[i].group == 'I') {
                    iflag = 1;
                  }
                  if(this.edit_statement_questions[i].group == 'J') {
                    jflag = 1;
                  }
                  if(this.edit_statement_questions[i].group == 'K') {
                    kflag = 1;
                  }
                }
              }
              if(sflag == 0) {
                alert("Please enter atleast one Statement/Questions");
                vflag = 0;
                return false;
              }
              if(aflag == 1) {
                var aaflag = 0;
                for(var i=0; i<this.edit_group_a_range.length; i++) {
                  if(this.edit_group_a_range[i].from != '') {
                    aaflag = 1;
                  }
                }
                if(aaflag == 0) {
                  alert("Please enter atleast one Output Range for Group A");
                  vflag = 0;
                  return false;
                }
              }
              else {
                this.edit_group_a_range = [{
                  from: '',
                  to: '',
                  text: '',
                }];

              }
              if(bflag == 1) {
                var bbflag = 0;
                for(var i=0; i<this.edit_group_b_range.length; i++) {
                  if(this.edit_group_b_range[i].from != '') {
                    bbflag = 1;
                  }
                }
                if(bbflag == 0) {
                  alert("Please enter atleast one Output Range for Group B");
                  vflag = 0;
                  return false;
                }
              }
              else {
                this.edit_group_b_range = [{
                  from: '',
                  to: '',
                  text: '',
                }];

              }
              if(cflag == 1) {
                var ccflag = 0;
                for(var i=0; i<this.edit_group_c_range.length; i++) {
                  if(this.edit_group_c_range[i].from != '') {
                    ccflag = 1;
                  }
                }
                if(ccflag == 0) {
                  alert("Please enter atleast one Output Range for Group C");
                  vflag = 0;
                  return false;
                }
              }
              else {
                this.edit_group_c_range = [{
                  from: '',
                  to: '',
                  text: '',
                }];

              }
              if(dflag == 1) {
                var ddflag = 0;
                for(var i=0; i<this.edit_group_d_range.length; i++) {
                  if(this.edit_group_d_range[i].from != '') {
                    ddflag = 1;
                  }
                }
                if(ddflag == 0) {
                  alert("Please enter atleast one Output Range for Group D");
                  vflag = 0;
                  return false;
                }
              }
              else {
                this.edit_group_d_range = [{
                  from: '',
                  to: '',
                  text: '',
                }];

              }
              if(eflag == 1) {
                var eeflag = 0;
                for(var i=0; i<this.edit_group_e_range.length; i++) {
                  if(this.edit_group_e_range[i].from != '') {
                    eeflag = 1;
                  }
                }
                if(eeflag == 0) {
                  alert("Please enter atleast one Output Range for Group E");
                  vflag = 0;
                  return false;
                }
              }
              else {
                this.edit_group_e_range = [{
                  from: '',
                  to: '',
                  text: '',
                }];

              }
              if(fflag == 1) {
                var ffflag = 0;
                for(var i=0; i<this.edit_group_f_range.length; i++) {
                  if(this.edit_group_f_range[i].from != '') {
                    ffflag = 1;
                  }
                }
                if(ffflag == 0) {
                  alert("Please enter atleast one Output Range for Group F");
                  vflag = 0;
                  return false;
                }
              }
              else {
                this.edit_group_f_range = [{
                  from: '',
                  to: '',
                  text: '',
                }];

              }
              if(gflag == 1) {
                var ggflag = 0;
                for(var i=0; i<this.edit_group_g_range.length; i++) {
                  if(this.edit_group_g_range[i].from != '') {
                    ggflag = 1;
                  }
                }
                if(ggflag == 0) {
                  alert("Please enter atleast one Output Range for Group G");
                  vflag = 0;
                  return false;
                }
              }
              else {
                this.edit_group_g_range = [{
                  from: '',
                  to: '',
                  text: '',
                }];

              }
              if(hflag == 1) {
                var hhflag = 0;
                for(var i=0; i<this.edit_group_h_range.length; i++) {
                  if(this.edit_group_h_range[i].from != '') {
                    hhflag = 1;
                  }
                }
                if(hhflag == 0) {
                  alert("Please enter atleast one Output Range for Group H");
                  vflag = 0;
                  return false;
                }
              }
              else {
                this.edit_group_h_range = [{
                  from: '',
                  to: '',
                  text: '',
                }];

              }
              if(iflag == 1) {
                var iiflag = 0;
                for(var i=0; i<this.edit_group_i_range.length; i++) {
                  if(this.edit_group_i_range[i].from != '') {
                    iiflag = 1;
                  }
                }
                if(iiflag == 0) {
                  alert("Please enter atleast one Output Range for Group I");
                  vflag = 0;
                  return false;
                }
              }
              else {
                this.edit_group_i_range = [{
                  from: '',
                  to: '',
                  text: '',
                }];

              }
              if(jflag == 1) {
                var jjflag = 0;
                for(var i=0; i<this.edit_group_j_range.length; i++) {
                  if(this.edit_group_j_range[i].from != '') {
                    jjflag = 1;
                  }
                }
                if(jjflag == 0) {
                  alert("Please enter atleast one Output Range for Group J");
                  vflag = 0;
                  return false;
                }
              }
              else {
                this.edit_group_j_range = [{
                  from: '',
                  to: '',
                  text: '',
                }];

              }
              if(kflag == 1) {
                var kkflag = 0;
                for(var i=0; i<this.edit_group_k_range.length; i++) {
                  if(this.edit_group_k_range[i].from != '') {
                    kkflag = 1;
                  }
                }
                if(kkflag == 0) {
                  alert("Please enter atleast one Output Range for Group K");
                  vflag = 0;
                  return false;
                }
              }
              else {
                this.edit_group_k_range = [{
                  from: '',
                  to: '',
                  text: '',
                }];

              }
              for(var i=0; i<this.edit_statement_questions.length; i++) {
                if(this.edit_section_range_display == true) {
                  if((this.edit_statement_questions[i].group != '') && ((this.edit_statement_questions[i].type == '') || (this.edit_statement_questions[i].text == ''))) {
                    if(this.edit_statement_questions[i].type == '') {
                      alert("Type should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_statement_questions[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                } 
                if((this.edit_statement_questions[i].type != '') && ((this.edit_statement_questions[i].group == '') || (this.edit_statement_questions[i].text == ''))) {
                  if(this.edit_section_range_display == true) {
                    if(this.edit_statement_questions[i].group == '') {
                      alert("Group should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if(this.edit_statement_questions[i].text == '') {
                    alert("Text should be not be empty");
                    vflag = 0;
                    return false;
                  }
                }
                if((this.edit_statement_questions[i].text != '') && ((this.edit_statement_questions[i].group == '') || (this.edit_statement_questions[i].type == ''))) {
                  if(this.edit_section_range_display == true) {
                    if(this.edit_statement_questions[i].group == '') {
                      alert("Group should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if(this.edit_statement_questions[i].type == '') {
                    alert("Type should be not be empty");
                    vflag = 0;
                    return false;
                  }
                }
              }
              if(aflag == 1) {


                var val = this.editGetMinMaxRange('A');
                var minRange = val[0].min;
                var maxRange = val[0].max;

                var last_to_range = '';var j;
                for(var i=this.edit_group_a_range.length; i>0; i--) {
                  j = parseInt(i - 1);
                  if((this.edit_group_a_range[j].from != '') && (this.edit_group_a_range[j].to != '')) {
                    last_to_range = j;
                    break;
                  }
                }  
                if(last_to_range > -1) {
                  if(this.edit_group_a_range[last_to_range].to != maxRange) {
                    alert("Last To range should be equal to the maximum range");
                    vflag = 0;
                    this.edit_group_a_range[last_to_range].to = '';
                    return false;
                  }
                }       
                for(var i=0; i<this.edit_group_a_range.length; i++) {

                  if((i == 0)) {
                    if(this.edit_group_a_range[i].from != minRange) {
                      alert("First From range should be equal to the count of questions of that group");
                      vflag = 0;
                      this.edit_group_a_range[i].from = '';
                      return false;
                    }
                  }



                  if((this.edit_group_a_range[i].from != '') && ((this.edit_group_a_range[i].to == '') || (this.edit_group_a_range[i].text == ''))) {
                    if(this.edit_group_a_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_a_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.edit_group_a_range[i].to != '') && ((this.edit_group_a_range[i].from == '') || (this.edit_group_a_range[i].text == ''))) {
                    if(this.edit_group_a_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_a_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.edit_group_a_range[i].text != '') && ((this.edit_group_a_range[i].from == '') || (this.edit_group_a_range[i].to == ''))) {
                    if(this.edit_group_a_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_a_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                }

              }
              if(bflag == 1) {

                var val = this.editGetMinMaxRange('B');
                var minRange = val[0].min;
                var maxRange = val[0].max;

                var last_to_range = '';var j;
                for(var i=this.edit_group_b_range.length; i>0; i--) {
                  j = parseInt(i - 1);
                  if((this.edit_group_b_range[j].from != '') && (this.edit_group_b_range[j].to != '')) {
                    last_to_range = j;
                    break;
                  }
                }  
                if(last_to_range > -1) {
                  if(this.edit_group_b_range[last_to_range].to != maxRange) {
                    alert("Last To range should be equal to the maximum range");
                    vflag = 0;
                    this.edit_group_b_range[last_to_range].to = '';
                    return false;
                  }
                }       

                for(var i=0; i<this.edit_group_b_range.length; i++) {
                  if((i == 0)) {
                    if(this.edit_group_b_range[i].from != minRange) {
                      alert("First From range should be equal to the count of questions of that group");
                      vflag = 0;
                      this.edit_group_b_range[i].from = '';
                      return false;
                    }
                  }


                  if((this.edit_group_b_range[i].from != '') && ((this.edit_group_b_range[i].to == '') || (this.edit_group_b_range[i].text == ''))) {
                    if(this.edit_group_b_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_b_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.edit_group_b_range[i].to != '') && ((this.edit_group_b_range[i].from == '') || (this.edit_group_b_range[i].text == ''))) {
                    if(this.edit_group_b_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_b_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.edit_group_b_range[i].text != '') && ((this.edit_group_b_range[i].from == '') || (this.edit_group_b_range[i].to == ''))) {
                    if(this.edit_group_b_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_b_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                }

              }
              if(cflag == 1) {

                var val = this.editGetMinMaxRange('C');
                var minRange = val[0].min;
                var maxRange = val[0].max;

                var last_to_range = '';var j;
                for(var i=this.edit_group_c_range.length; i>0; i--) {
                  j = parseInt(i - 1);
                  if((this.edit_group_c_range[j].from != '') && (this.edit_group_c_range[j].to != '')) {
                    last_to_range = j;
                    break;
                  }
                }  
                if(last_to_range > -1) {
                  if(this.edit_group_c_range[last_to_range].to != maxRange) {
                    alert("Last To range should be equal to the maximum range");
                    vflag = 0;
                    this.edit_group_c_range[last_to_range].to = '';
                    return false;
                  }
                }       

                for(var i=0; i<this.edit_group_c_range.length; i++) {
                  if((i == 0)) {
                    if(this.edit_group_c_range[i].from != minRange) {
                      alert("First From range should be equal to the count of questions of that group");
                      vflag = 0;
                      this.edit_group_c_range[i].from = '';
                      return false;
                    }
                  }


                  if((this.edit_group_c_range[i].from != '') && ((this.edit_group_c_range[i].to == '') || (this.edit_group_c_range[i].text == ''))) {
                    if(this.edit_group_c_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_c_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.edit_group_c_range[i].to != '') && ((this.edit_group_c_range[i].from == '') || (this.edit_group_c_range[i].text == ''))) {
                    if(this.edit_group_c_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_c_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.edit_group_c_range[i].text != '') && ((this.edit_group_c_range[i].from == '') || (this.edit_group_c_range[i].to == ''))) {
                    if(this.edit_group_c_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_c_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                }

              }
              if(dflag == 1) {

                var val = this.editGetMinMaxRange('D');
                var minRange = val[0].min;
                var maxRange = val[0].max;

                var last_to_range = '';var j;
                for(var i=this.edit_group_d_range.length; i>0; i--) {
                  j = parseInt(i - 1);
                  if((this.edit_group_d_range[j].from != '') && (this.edit_group_d_range[j].to != '')) {
                    last_to_range = j;
                    break;
                  }
                }  
                if(last_to_range > -1) {
                  if(this.edit_group_d_range[last_to_range].to != maxRange) {
                    alert("Last To range should be equal to the maximum range");
                    vflag = 0;
                    this.edit_group_d_range[last_to_range].to = '';
                    return false;
                  }
                }       

                for(var i=0; i<this.edit_group_d_range.length; i++) {
                  if((i == 0)) {
                    if(this.edit_group_d_range[i].from != minRange) {
                      alert("First From range should be equal to the count of questions of that group");
                      vflag = 0;
                      this.edit_group_d_range[i].from = '';
                      return false;
                    }
                  }


                  if((this.edit_group_d_range[i].from != '') && ((this.edit_group_d_range[i].to == '') || (this.edit_group_d_range[i].text == ''))) {
                    if(this.edit_group_d_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_d_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.edit_group_d_range[i].to != '') && ((this.edit_group_d_range[i].from == '') || (this.edit_group_d_range[i].text == ''))) {
                    if(this.edit_group_d_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_d_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.edit_group_d_range[i].text != '') && ((this.edit_group_d_range[i].from == '') || (this.edit_group_d_range[i].to == ''))) {
                    if(this.edit_group_d_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_d_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                }

              }
              if(eflag == 1) {

                var val = this.editGetMinMaxRange('E');
                var minRange = val[0].min;
                var maxRange = val[0].max;

                var last_to_range = '';var j;
                for(var i=this.edit_group_e_range.length; i>0; i--) {
                  j = parseInt(i - 1);
                  if((this.edit_group_e_range[j].from != '') && (this.edit_group_e_range[j].to != '')) {
                    last_to_range = j;
                    break;
                  }
                }  
                if(last_to_range > -1) {
                  if(this.edit_group_e_range[last_to_range].to != maxRange) {
                    alert("Last To range should be equal to the maximum range");
                    vflag = 0;
                    this.edit_group_e_range[last_to_range].to = '';
                    return false;
                  }
                }       

                for(var i=0; i<this.edit_group_e_range.length; i++) {
                  if((i == 0)) {
                    if(this.edit_group_e_range[i].from != minRange) {
                      alert("First From range should be equal to the count of questions of that group");
                      vflag = 0;
                      this.edit_group_e_range[i].from = '';
                      return false;
                    }
                  }


                  if((this.edit_group_e_range[i].from != '') && ((this.edit_group_e_range[i].to == '') || (this.edit_group_e_range[i].text == ''))) {
                    if(this.edit_group_e_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_e_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.edit_group_e_range[i].to != '') && ((this.edit_group_e_range[i].from == '') || (this.edit_group_e_range[i].text == ''))) {
                    if(this.edit_group_e_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_e_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.edit_group_e_range[i].text != '') && ((this.edit_group_e_range[i].from == '') || (this.edit_group_e_range[i].to == ''))) {
                    if(this.edit_group_e_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_e_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                }

              }
              if(fflag == 1) {

                var val = this.editGetMinMaxRange('F');
                var minRange = val[0].min;
                var maxRange = val[0].max;

                var last_to_range = '';var j;
                for(var i=this.edit_group_f_range.length; i>0; i--) {
                  j = parseInt(i - 1);
                  if((this.edit_group_f_range[j].from != '') && (this.edit_group_f_range[j].to != '')) {
                    last_to_range = j;
                    break;
                  }
                }  
                if(last_to_range > -1) {
                  if(this.edit_group_f_range[last_to_range].to != maxRange) {
                    alert("Last To range should be equal to the maximum range");
                    vflag = 0;
                    this.edit_group_f_range[last_to_range].to = '';
                    return false;
                  }
                }       

                for(var i=0; i<this.edit_group_f_range.length; i++) {
                  if((i == 0)) {
                    if(this.edit_group_f_range[i].from != minRange) {
                      alert("First From range should be equal to the count of questions of that group");
                      vflag = 0;
                      this.edit_group_f_range[i].from = '';
                      return false;
                    }
                  }


                  if((this.edit_group_f_range[i].from != '') && ((this.edit_group_f_range[i].to == '') || (this.edit_group_f_range[i].text == ''))) {
                    if(this.edit_group_f_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_f_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.edit_group_f_range[i].to != '') && ((this.edit_group_f_range[i].from == '') || (this.edit_group_f_range[i].text == ''))) {
                    if(this.edit_group_f_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_f_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.edit_group_f_range[i].text != '') && ((this.edit_group_f_range[i].from == '') || (this.edit_group_f_range[i].to == ''))) {
                    if(this.edit_group_f_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_f_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                }

              }
              if(gflag == 1) {

                var val = this.editGetMinMaxRange('G');
                var minRange = val[0].min;
                var maxRange = val[0].max;

                var last_to_range = '';var j;
                for(var i=this.edit_group_g_range.length; i>0; i--) {
                  j = parseInt(i - 1);
                  if((this.edit_group_g_range[j].from != '') && (this.edit_group_g_range[j].to != '')) {
                    last_to_range = j;
                    break;
                  }
                }  
                if(last_to_range > -1) {
                  if(this.edit_group_g_range[last_to_range].to != maxRange) {
                    alert("Last To range should be equal to the maximum range");
                    vflag = 0;
                    this.edit_group_g_range[last_to_range].to = '';
                    return false;
                  }
                }       

                for(var i=0; i<this.edit_group_g_range.length; i++) {
                  if((i == 0)) {
                    if(this.edit_group_g_range[i].from != minRange) {
                      alert("First From range should be equal to the count of questions of that group");
                      vflag = 0;
                      this.edit_group_g_range[i].from = '';
                      return false;
                    }
                  }


                  if((this.edit_group_g_range[i].from != '') && ((this.edit_group_g_range[i].to == '') || (this.edit_group_g_range[i].text == ''))) {
                    if(this.edit_group_g_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_g_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.edit_group_g_range[i].to != '') && ((this.edit_group_g_range[i].from == '') || (this.edit_group_g_range[i].text == ''))) {
                    if(this.edit_group_g_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_g_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.edit_group_g_range[i].text != '') && ((this.edit_group_g_range[i].from == '') || (this.edit_group_g_range[i].to == ''))) {
                    if(this.edit_group_g_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_g_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                }

              }
              if(hflag == 1) {

                var val = this.editGetMinMaxRange('H');
                var minRange = val[0].min;
                var maxRange = val[0].max;

                var last_to_range = '';var j;
                for(var i=this.edit_group_h_range.length; i>0; i--) {
                  j = parseInt(i - 1);
                  if((this.edit_group_h_range[j].from != '') && (this.edit_group_h_range[j].to != '')) {
                    last_to_range = j;
                    break;
                  }
                }  
                if(last_to_range > -1) {
                  if(this.edit_group_h_range[last_to_range].to != maxRange) {
                    alert("Last To range should be equal to the maximum range");
                    vflag = 0;
                    this.edit_group_h_range[last_to_range].to = '';
                    return false;
                  }
                }       

                for(var i=0; i<this.edit_group_h_range.length; i++) {
                  if((i == 0)) {
                    if(this.edit_group_h_range[i].from != minRange) {
                      alert("First From range should be equal to the count of questions of that group");
                      vflag = 0;
                      this.edit_group_h_range[i].from = '';
                      return false;
                    }
                  }


                  if((this.edit_group_h_range[i].from != '') && ((this.edit_group_h_range[i].to == '') || (this.edit_group_h_range[i].text == ''))) {
                    if(this.edit_group_h_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_h_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.edit_group_h_range[i].to != '') && ((this.edit_group_h_range[i].from == '') || (this.edit_group_h_range[i].text == ''))) {
                    if(this.edit_group_h_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_h_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.edit_group_h_range[i].text != '') && ((this.edit_group_h_range[i].from == '') || (this.edit_group_h_range[i].to == ''))) {
                    if(this.edit_group_h_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_h_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                }

              }
              if(iflag == 1) {

                var val = this.editGetMinMaxRange('I');
                var minRange = val[0].min;
                var maxRange = val[0].max;

                var last_to_range = '';var j;
                for(var i=this.edit_group_i_range.length; i>0; i--) {
                  j = parseInt(i - 1);
                  if((this.edit_group_i_range[j].from != '') && (this.edit_group_i_range[j].to != '')) {
                    last_to_range = j;
                    break;
                  }
                }  
                if(last_to_range > -1) {
                  if(this.edit_group_i_range[last_to_range].to != maxRange) {
                    alert("Last To range should be equal to the maximum range");
                    vflag = 0;
                    this.edit_group_i_range[last_to_range].to = '';
                    return false;
                  }
                }       

                for(var i=0; i<this.edit_group_i_range.length; i++) {
                  if((i == 0)) {
                    if(this.edit_group_i_range[i].from != minRange) {
                      alert("First From range should be equal to the count of questions of that group");
                      vflag = 0;
                      this.edit_group_i_range[i].from = '';
                      return false;
                    }
                  }


                  if((this.edit_group_i_range[i].from != '') && ((this.edit_group_i_range[i].to == '') || (this.edit_group_i_range[i].text == ''))) {
                    if(this.edit_group_i_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_i_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.edit_group_i_range[i].to != '') && ((this.edit_group_i_range[i].from == '') || (this.edit_group_i_range[i].text == ''))) {
                    if(this.edit_group_i_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_i_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.edit_group_i_range[i].text != '') && ((this.edit_group_i_range[i].from == '') || (this.edit_group_i_range[i].to == ''))) {
                    if(this.edit_group_i_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_i_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                }

              }
              if(jflag == 1) {

                var val = this.editGetMinMaxRange('J');
                var minRange = val[0].min;
                var maxRange = val[0].max;

                var last_to_range = '';var j;
                for(var i=this.edit_group_j_range.length; i>0; i--) {
                  j = parseInt(i - 1);
                  if((this.edit_group_j_range[j].from != '') && (this.edit_group_j_range[j].to != '')) {
                    last_to_range = j;
                    break;
                  }
                }
                if(last_to_range > -1) {
                  if(this.edit_group_j_range[last_to_range].to != maxRange) {
                    alert("Last To range should be equal to the maximum range");
                    vflag = 0;
                    this.edit_group_j_range[last_to_range].to = '';
                    return false;
                  }
                }       

                for(var i=0; i<this.edit_group_j_range.length; i++) {
                  if((i == 0)) {
                    if(this.edit_group_j_range[i].from != minRange) {
                      alert("First From range should be equal to the count of questions of that group");
                      vflag = 0;
                      this.edit_group_j_range[i].from = '';
                      return false;
                    }
                  }


                  if((this.edit_group_j_range[i].from != '') && ((this.edit_group_j_range[i].to == '') || (this.edit_group_j_range[i].text == ''))) {
                    if(this.edit_group_j_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_j_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.edit_group_j_range[i].to != '') && ((this.edit_group_j_range[i].from == '') || (this.edit_group_j_range[i].text == ''))) {
                    if(this.edit_group_j_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_j_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.edit_group_j_range[i].text != '') && ((this.edit_group_j_range[i].from == '') || (this.edit_group_j_range[i].to == ''))) {
                    if(this.edit_group_j_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_j_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                }

              }
              if(kflag == 1) {

                var val = this.editGetMinMaxRange('K');
                var minRange = val[0].min;
                var maxRange = val[0].max;

                var last_to_range = '';var j;
                for(var i=this.edit_group_k_range.length; i>0; i--) {
                  j = parseInt(i - 1);
                  if((this.edit_group_k_range[j].from != '') && (this.edit_group_k_range[j].to != '')) {
                    last_to_range = j;
                    break;
                  }
                }  
                if(last_to_range > -1) {
                  if(this.edit_group_k_range[last_to_range].to != maxRange) {
                    alert("Last To range should be equal to the maximum range");
                    vflag = 0;
                    this.edit_group_k_range[last_to_range].to = '';
                    return false;
                  }
                }       

                for(var i=0; i<this.edit_group_k_range.length; i++) {
                  if((i == 0)) {
                    if(this.edit_group_k_range[i].from != minRange) {
                      alert("First From range should be equal to the count of questions of that group");
                      vflag = 0;
                      this.edit_group_k_range[i].from = '';
                      return false;
                    }
                  }


                  if((this.edit_group_k_range[i].from != '') && ((this.edit_group_k_range[i].to == '') || (this.edit_group_k_range[i].text == ''))) {
                    if(this.edit_group_k_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_k_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.edit_group_k_range[i].to != '') && ((this.edit_group_k_range[i].from == '') || (this.edit_group_k_range[i].text == ''))) {
                    if(this.edit_group_k_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_k_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.edit_group_k_range[i].text != '') && ((this.edit_group_k_range[i].from == '') || (this.edit_group_k_range[i].to == ''))) {
                    if(this.edit_group_k_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.edit_group_k_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                }

              }

              return vflag;

            },
            validateSameRangeInGroup: function(rangeArr, rangeName) {
              var vsRange = 1; 
              var prevFrom = 0; 
              var prevTo = 0;
              var prevIndex = 0;
              var rangeCount = rangeArr.length;
              for (var i=0; i < rangeCount; i++) {
                if (rangeArr[i].from == "" || rangeArr[i].to == "") {
                  return true;
                }
                if (prevFrom == rangeArr[i].from && prevTo == rangeArr[i].to) {
                  alert("From range and To range are already exists in the Group " + rangeName);
                  rangeArr[i].from = '';
                  vsRange = 0;
                }
                if ((i + 1) == rangeCount && rangeCount > 1) {
                  if(parseInt(rangeArr[i].from) <= parseInt(rangeArr[prevIndex].to)) {
                    alert("From range should be higher than the previous To range");
                    rangeArr[i].from = '';
                    vsRange = 0;
                  }
                }
                prevFrom = rangeArr[i].from;
                prevTo = rangeArr[i].to;
                prevIndex = i;
              }
              return vsRange;
            },
           editAssessmentSection: function(e) {
            this.$validator.validateAll().then((result) => {
              if ((this.verrors.items.length === 0)) {
                  var vflag = this.editdoValidate();
                  var vaflag = this.validateSameRangeInGroup(this.edit_group_a_range, 'A');
                  var vbflag = this.validateSameRangeInGroup(this.edit_group_b_range, 'B');
                  var vcflag = this.validateSameRangeInGroup(this.edit_group_c_range, 'C');
                  var vdflag = this.validateSameRangeInGroup(this.edit_group_d_range, 'D');
                  var veflag = this.validateSameRangeInGroup(this.edit_group_e_range, 'E');
                  var vfflag = this.validateSameRangeInGroup(this.edit_group_f_range, 'F');
                  var vgflag = this.validateSameRangeInGroup(this.edit_group_g_range, 'G');
                  var vhflag = this.validateSameRangeInGroup(this.edit_group_h_range, 'H');
                  var viflag = this.validateSameRangeInGroup(this.edit_group_i_range, 'I');
                  var vjflag = this.validateSameRangeInGroup(this.edit_group_j_range, 'J');
                  var vkflag = this.validateSameRangeInGroup(this.edit_group_k_range, 'K');
                  if (!vaflag || !vbflag || !vcflag || !vdflag || !veflag || !vfflag || !vgflag || !vhflag || !viflag || !vjflag || !vkflag) {
                    vflag = 0;
                  }
                  if(vflag == 1) {
                  
                    axios('/assessment-section/' + this.sectionId,
                       {
                         method: 'PATCH',
                         data:
                          {
                            title: this.edit_assessment_section_title,
                            scale: this.edit_scale,
                            type: this.edit_section_type,
                            questions: this.edit_statement_questions,
                            group_a: this.edit_group_a_range,
                            group_b: this.edit_group_b_range,
                            group_c: this.edit_group_c_range,
                            group_d: this.edit_group_d_range,
                            group_e: this.edit_group_e_range,
                            group_f: this.edit_group_f_range,
                            group_g: this.edit_group_g_range,
                            group_h: this.edit_group_h_range,
                            group_i: this.edit_group_i_range,
                            group_j: this.edit_group_j_range,
                            group_k: this.edit_group_k_range,
                            remove_questions: this.remove_question_ids,
                          },
                       }
                     )
                    .then((resp) => {
                        this.edit_assessment_section_title = '';
                        this.edit_scale = '';
                        this.edit_section_type = 'output';
                        this.edit_statement_questions = [
                          {
                            id: '',
                            updated: false,
                            modified: false,
                            group: '',
                            type: '',
                            text: '',
                          }
                        ];
                        this.edit_egroup_a_range = [
                          {
                            from: '',
                            to: '',
                            text: '',
                          }
                        ];
                        this.edit_group_b_range = [
                          {
                            from: '',
                            to: '',
                            text: '',
                          }
                        ];
                        this.edit_group_c_range = [
                          {
                            from: '',
                            to: '',
                            text: '',
                          }
                        ];
                        this.edit_group_d_range = [
                          {
                            from: '',
                            to: '',
                            text: '',
                          }
                        ];
                        this.edit_group_e_range = [
                          {
                            from: '',
                            to: '',
                            text: '',
                          }
                        ];
                        this.edit_group_f_range = [
                          {
                            from: '',
                            to: '',
                            text: '',
                          }
                        ];
                        this.edit_group_g_range = [
                          {
                            from: '',
                            to: '',
                            text: '',
                          }
                        ];
                        this.edit_group_h_range = [
                          {
                            from: '',
                            to: '',
                            text: '',
                          }
                        ];
                        this.edit_group_i_range = [
                          {
                            from: '',
                            to: '',
                            text: '',
                          }
                        ];
                        this.edit_group_j_range = [
                          {
                            from: '',
                            to: '',
                            text: '',
                          }
                        ];
                        this.edit_group_k_range = [
                          {
                            from: '',
                            to: '',
                            text: '',
                          }
                        ];
                        this.remove_question_ids = [];
                        this.$emit('close');
                        this.$parent.fetchAssessmentSectionitems();

                     })
                    .catch(error => {
                      if(error.response.data.message == 'Access denied.') {
                        router.push("/forbidden");
                      }
                    });
                }
               }
              })
          }
      }
 }             
                  
</script>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;   
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
}
.modal-container {
    postition: fixed;
    width: 1000px;
    margin: 40px auto 0;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    overflow-y: auto;
    height: 600px;
}
.modal-body {
    margin: 0px;
    padding: 10px;
}
@media(max-width:560px) {
  .modal-container {
    width: 98%;
    padding: 20px 20px;
  }
  .modal-body {
      margin: 0px;
      padding: 0px;
  }
}

.modal-header .sub-heading {
  background-color: #FFF;
  color: #555;
}
.modal-header {
  padding: 5px;
  border: 0px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.modal-footer {
  border-top: none;
}
.btn-info, .btn-info:hover, .btn-info:focus {
  background-color: #C3C3C3 !important;
  border: 1px solid #CCC !important;
  color: #000;
}
.btn {
  padding: 1px 0px;
}
.delete-icon {
  color: #FF0000;
}
.reps_history_label a, .reps_history_label a:active, .reps_history_label a:focus {
  color: #000 !important;
  text-decoration: none !important;
}
.reps_history_label i {
  float: right;
  font-size: 22px !important;
  font-weight: bold;
  padding-top: 2px;
  color: #CBCBCB;
}
.reps_history_label { 
  text-align: left; 
  font-weight: bold; 
  margin: 0;
}
.custom_hr {
  border-bottom: 1px solid #e8e8e8;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/edit_assessment_section_modal.vue